import React from 'react'
import './Encryption.scss';
import EncryptionImage from '../../assets/EncryptionImage.png';
import EncryptionMobileImage from '../../assets/EncryptionMobileImage.png';

export default function Encryption() {
  return (
    <div className='encryption-container'>
        <div className='encryption-heading-container'>
          <h1>Securely Share Your Files via Gmail & WhatsApp - Encrypt Before You Send!</h1>
        </div>
        <div className='encryption-image-container'>
          <img src={EncryptionImage} alt="encryption" />
        </div>
        <div className='encryption-mobile-image-container'>
          <img src={EncryptionMobileImage} alt="encryption" />
        </div>
      
    </div>
  )
}
